import axios from "axios";

const axiosInstance = axios.create();

const renewToken = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/auth/refresh-token`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("refresh_token")}`,
        },
      }
    );

    localStorage.setItem("access_token", res.data.data.access_token);
    localStorage.setItem("refresh_token", res.data.data.refresh_token);

    return res.data.data.access_token;
  } catch (_) {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}/auth/logout`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          localStorage.clear();
        }
      })
      .catch((err) => {
        console.error(err);
      });

    localStorage.clear();
    window.location.href = "/auth/sign-in";
    return await Promise.reject();
  }
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    config.baseURL = process.env.REACT_APP_API_ENDPOINT;
    config.headers = Object.assign(
      {
        ...config.headers,
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
      config.headers
    );
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (config) => {
    let token = localStorage.getItem("token");
    config.headers = Object.assign(
      {
        ...config.headers,
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      config.headers
    );
    return config;
  },
  async (error) => {
    const originalRequest = error.config;
    const isInLoginPage = window.location.pathname === "/auth/sign-in";

    if (
      error?.response?.status === 401 &&
      !isInLoginPage &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      const newAccessToken = await renewToken();
      originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
      return axiosInstance(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
